import { isStaging, MULTI_REGION_TARGETS } from '@/app/const';
import { FormItem, Paragraph, SelectList } from 'elmo-elements';
import React, { useState } from 'react';

interface MultiRegionSelectListProps {
  currentNamespace: string;
  onChange: (selectedRegions: string[]) => void;
}

type TSetOfStrings = Set<string>;

const MultiRegionSelectList = ({
  currentNamespace,
  onChange,
}: MultiRegionSelectListProps) => {
  const [selectedRegions, setSelectedRegions] = useState<TSetOfStrings>(
    new Set(),
  );

  const availableRegions = isStaging
    ? MULTI_REGION_TARGETS
    : MULTI_REGION_TARGETS.filter(
        (region) => region.namespace !== currentNamespace,
      );

  const handleSelectAllToggle = () => {
    if (selectedRegions.size === availableRegions.length) {
      setSelectedRegions(new Set());
      onChange([]);
    } else {
      const allNamespaces = availableRegions.map((region) => region.namespace);

      setSelectedRegions(new Set(allNamespaces));
      onChange(allNamespaces);
    }
  };

  const handleToggle = (namespace: string) => {
    setSelectedRegions((prev) => {
      const next = new Set(prev);

      if (next.has(namespace)) {
        next.delete(namespace);
      } else {
        next.add(namespace);
      }
      onChange([...next]);

      return next;
    });
  };

  return (
    <FormItem className="multiRegionContainer" label="Select target regions:">
      <SelectList onSelectAllToggle={handleSelectAllToggle}>
        {availableRegions.map((region) => (
          <SelectList.Option
            key={region.namespace}
            isSelected={selectedRegions.has(region.namespace)}
            onToggle={() => handleToggle(region.namespace)}
          >
            <Paragraph className="multiRegion-label">{region.name}</Paragraph>
          </SelectList.Option>
        ))}
      </SelectList>
    </FormItem>
  );
};

export default MultiRegionSelectList;
